{
    "InlineExitMessage": "Tem a certeza de que pretende fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "InlineExitConfirm": "Confirmar",
    "InlineExitCancel": "Cancelar",
    "NotificationsModalTitle": "Notificações",
    "TabSettingsTitle": "Definições",
    "TabSettingsDoNotDisturb": "Ativar",
    "TabSettingsCME": "CME",
    "TabSettingsTelServer": "Servidor de telefonia",
    "TabSettingsPartition": "Partição \/ Local",
    "TabSettingsDevices": "Dispositivos",
    "TabSettingsChannels": "Canais",
    "TabSettingsPhoneNumber": "Número de telefone",
    "TabSettingsHeaderGeneral": "Geral",
    "TabSettingsHeaderScopeFiltering": "Filtragem de âmbito",
    "TabSettingsNotificationChannels": "Canais de notificação",
    "TabSetttingsPartitionValidation": "Só é possível selecionar um máximo de 5 partições.",
    "TabPreferencesTitle": "Preferências",
    "TabPreferencesHeadingUserNotifications": "Notificações do utilizador",
    "IconAddTooltip": "Adicionar notificações",
    "IconDisabledTooltip": "As notificações estão desativadas",
    "IconEnabledTooltip": "As notificações estão ativadas",
    "IconDisabled": "Desativado",
    "NotificationsFooterHelp": "Ajuda",
    "NotificationsFooterCancel": "Cancelar",
    "NotificationsFooterSubmit": "Guardar",
    "NotificationsFooterValiationWarning": "Por favor, corrija os erros antes de terminar",
    "NotificationPrefereencesThreshholdPlaceholder": "Espaço reservado",
    "NotificationPrefereencesThreshholdRequired": "O limiar é necessário",
    "NotificationPrefereencesThreshholdInvalid": "O limiar deve ser um número",
    "NotificationFooterValidationError": "Erros de validação",
    "NAME": "NotificationsLanguageModal"
}